// extracted by mini-css-extract-plugin
export default {"remind-content":"remind-content___ITE1F","notice":"notice___ruo7_","icon":"icon___qFyNb"};